import { cx } from "../../../Util/classHelpers";
import styles from "./shimmer.module.css";

const normalizeSize = (value) =>
  typeof value === "number" ? `${value}px` : value;

const normalizeRadius = (value) =>
  typeof value === "number" ? `${value}px` : value;

const Shimmer = ({
  width = 32,
  height = 16,
  borderRadius = 8,
  className,
  style,
}) => {
  const inlineStyle = {
    width: normalizeSize(width),
    height: normalizeSize(height),
    borderRadius: normalizeRadius(borderRadius),
    ...style,
  };

  return <div className={cx(styles.shimmer, className)} style={inlineStyle} aria-hidden="true" />;
};

export default Shimmer;
